// Active icon pack. Auto-registered as the `icons` Vuex namespace
// (see src/lib/store/modules/index.js). Persisted to localStorage so the
// choice survives reloads, mirroring the appearance module.
import { listPacks, hasPack, DEFAULT_PACK } from '@/lib/icons/registry'

const STORAGE_KEY = 'iconPack'

function loadPack() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved && hasPack(saved)) return saved
  } catch (e) {
    /* ignore storage errors */
  }
  return DEFAULT_PACK
}

export const state = {
  pack: loadPack()
}

export const getters = {
  iconPack: (s) => s.pack,
  availablePacks: () => listPacks()
}

export const mutations = {
  SET_ICON_PACK(s, v) {
    s.pack = v
  }
}

export const actions = {
  setIconPack({ commit }, value) {
    const pack = hasPack(value) ? value : DEFAULT_PACK
    commit('SET_ICON_PACK', pack)
    try {
      localStorage.setItem(STORAGE_KEY, pack)
    } catch (e) {
      /* ignore storage errors */
    }
  }
}
